import { useSearchParams } from 'react-router';
import { currentCompetencia, isCompetencia } from '@agencia/shared';
import { mesesDisponiveis, TIMEZONE } from './format';

/** Mês escolhido na tela, guardado na URL (?mes=2026-11) para links e "voltar" funcionarem. */
export function useMonth(): [string, (c: string) => void] {
  const [params, setParams] = useSearchParams();
  const raw = params.get('mes');
  const mes = raw && isCompetencia(raw) && mesesDisponiveis().includes(raw) ? raw : currentCompetencia(new Date(), TIMEZONE);
  return [
    mes,
    (c: string) =>
      setParams((p) => {
        p.set('mes', c);
        return p;
      }),
  ];
}
